import moment from 'moment';

export const BalanceSheetLoadingData = [
  {
    id: '1',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      value: '0',
      date: moment().subtract(3, 'months').format('MM/DD/YYYY'),
    },
  },
  {
    id: '1',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      value: '0',
      date: moment().subtract(2, 'months').format('MM/DD/YYYY'),
    },
  },
  {
    id: '1',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      value: '0',
      date: moment().subtract(1, 'months').format('MM/DD/YYYY'),
    },
  },
  {
    id: '1',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      value: '0',
      date: moment().format('MM/DD/YYYY'),
    },
  },
  {
    id: '2',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      value: '0',
      date: moment().add(1, 'months').format('MM/DD/YYYY'),
    },
  },
  {
    id: '2',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      value: '0',
      date: moment().add(2, 'months').format('MM/DD/YYYY'),
    },
  },
  {
    id: '2',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      value: '0',
      date: moment().add(3, 'months').format('MM/DD/YYYY'),
    },
  },
];

export const AccountPerformanceLoadingData = [
  {
    id: '1941',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10325.680000',
      percentageValue: '0.000000',
      color: '#195A7C',
      date: '2021-07-24T00:00:00Z',
    },
  },
  {
    id: '1942',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10325.680000',
      percentageValue: '0.000000',
      color: '#195A7C',
      date: '2021-07-25T00:00:00Z',
    },
  },
  {
    id: '1943',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10324.300000',
      percentageValue: '-0.000100',
      color: '#195A7C',
      date: '2021-07-26T00:00:00Z',
    },
  },
  {
    id: '1944',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10319.440000',
      percentageValue: '-0.000300',
      color: '#195A7C',
      date: '2021-07-27T00:00:00Z',
    },
  },
  {
    id: '1945',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10304.500000',
      percentageValue: '0.000200',
      color: '#195A7C',
      date: '2021-07-28T00:00:00Z',
    },
  },
  {
    id: '1946',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10317.790000',
      percentageValue: '0.000700',
      color: '#195A7C',
      date: '2021-07-29T00:00:00Z',
    },
  },
  {
    id: '1947',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10306.940000',
      percentageValue: '0.000200',
      color: '#195A7C',
      date: '2021-07-30T00:00:00Z',
    },
  },
  {
    id: '1948',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10316.940000',
      percentageValue: '0.000200',
      color: '#195A7C',
      date: '2021-07-31T00:00:00Z',
    },
  },
  {
    id: '1949',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10319.940000',
      percentageValue: '0.000200',
      color: '#195A7C',
      date: '2021-08-01T00:00:00Z',
    },
  },
  {
    id: '1950',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10321.630000',
      percentageValue: '0.000300',
      color: '#195A7C',
      date: '2021-08-02T00:00:00Z',
    },
  },
  {
    id: '1951',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10322.000000',
      percentageValue: '0.001200',
      color: '#195A7C',
      date: '2021-08-03T00:00:00Z',
    },
  },
  {
    id: '1952',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10328.230000',
      percentageValue: '0.000400',
      color: '#195A7C',
      date: '2021-08-04T00:00:00Z',
    },
  },
  {
    id: '1953',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10330.970000',
      percentageValue: '0.000800',
      color: '#195A7C',
      date: '2021-08-05T00:00:00Z',
    },
  },
  {
    id: '1954',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10330.030000',
      percentageValue: '0.000500',
      color: '#195A7C',
      date: '2021-08-06T00:00:00Z',
    },
  },
  {
    id: '1955',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10336.030000',
      percentageValue: '0.000500',
      color: '#195A7C',
      date: '2021-08-07T00:00:00Z',
    },
  },
  {
    id: '1956',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10336.030000',
      percentageValue: '0.000400',
      color: '#195A7C',
      date: '2021-08-08T00:00:00Z',
    },
  },
  {
    id: '1957',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10323.950000',
      percentageValue: '0.000200',
      color: '#195A7C',
      date: '2021-08-09T00:00:00Z',
    },
  },
  {
    id: '1958',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10324.930000',
      percentageValue: '0.000400',
      color: '#195A7C',
      date: '2021-08-10T00:00:00Z',
    },
  },
  {
    id: '1959',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10319.830000',
      percentageValue: '0.000800',
      color: '#195A7C',
      date: '2021-08-11T00:00:00Z',
    },
  },
  {
    id: '1960',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10315.390000',
      percentageValue: '0.000800',
      color: '#195A7C',
      date: '2021-08-12T00:00:00Z',
    },
  },
  {
    id: '1961',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10310.200000',
      percentageValue: '0.001100',
      color: '#195A7C',
      date: '2021-08-13T00:00:00Z',
    },
  },
  {
    id: '1962',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10315.200000',
      percentageValue: '0.001100',
      color: '#195A7C',
      date: '2021-08-14T00:00:00Z',
    },
  },
  {
    id: '1963',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10319.200000',
      percentageValue: '0.001100',
      color: '#195A7C',
      date: '2021-08-15T00:00:00Z',
    },
  },
  {
    id: '1964',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10320.260000',
      percentageValue: '0.001000',
      color: '#195A7C',
      date: '2021-08-16T00:00:00Z',
    },
  },
  {
    id: '1965',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10324.670000',
      percentageValue: '0.000200',
      color: '#195A7C',
      date: '2021-08-17T00:00:00Z',
    },
  },
  {
    id: '1966',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10328.560000',
      percentageValue: '-0.000700',
      color: '#195A7C',
      date: '2021-08-18T00:00:00Z',
    },
  },
  {
    id: '1967',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10330.950000',
      percentageValue: '-0.001200',
      color: '#195A7C',
      date: '2021-08-19T00:00:00Z',
    },
  },
  {
    id: '1968',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10325.950000',
      percentageValue: '-0.000500',
      color: '#195A7C',
      date: '2021-08-20T00:00:00Z',
    },
  },
  {
    id: '1969',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10327.950000',
      percentageValue: '-0.000600',
      color: '#195A7C',
      date: '2021-08-21T00:00:00Z',
    },
  },
  {
    id: '1970',
    type: 'chartDataPoint',
    links: {},
    relationships: {},
    attributes: {
      type: '',
      label: 'Account',
      value: '10340.000000',
      percentageValue: '-0.000600',
      color: '#195A7C',
      date: '2021-08-22T00:00:00Z',
    },
  },
];

export const AllocationLoadingData = [
  {
    id: '1',
    type: 'portfolio',
    links: {},
    relationships: {},
    attributes: {
      categoryChartData: [
        {
          id: 'large-cap',
          type: '',
          links: {},
          relationships: {},
          attributes: {
            color: 'rgba(25, 90, 124, 1)',
            date: '',
            type: 'Stocks',
            label: 'Large Domestic',
            value: '4136.00',
            percentageValue: '40.0%',
          },
          meta: {
            type: '',
            template: [
              {
                name: 'color',
                prompt: 'Color',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'date',
                prompt: 'Date',
                required: false,
                readonly: false,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'type',
                prompt: 'Type',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'label',
                prompt: 'Label',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'value',
                prompt: 'Value',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                precision: 3,
                isObjectId: false,
              },
              {
                name: 'percentageValue',
                prompt: 'PercentageValue',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                hint: 'percent',
                precision: 2,
                isObjectId: false,
              },
            ],
            links: {},
            page: {},
          },
        },
        {
          id: 'us-corp-bond',
          type: '',
          links: {},
          relationships: {},
          attributes: {
            color: 'rgba(56, 152, 123, .8)',
            date: '',
            type: 'Bonds',
            label: 'Corporate Bond',
            value: '3102.00',
            percentageValue: '30.0%',
          },
          meta: {
            type: '',
            template: [
              {
                name: 'color',
                prompt: 'Color',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'date',
                prompt: 'Date',
                required: false,
                readonly: false,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'type',
                prompt: 'Type',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'label',
                prompt: 'Label',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'value',
                prompt: 'Value',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                precision: 3,
                isObjectId: false,
              },
              {
                name: 'percentageValue',
                prompt: 'PercentageValue',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                hint: 'percent',
                precision: 2,
                isObjectId: false,
              },
            ],
            links: {},
            page: {},
          },
        },
        {
          id: 'mid-cap',
          type: '',
          links: {},
          relationships: {},
          attributes: {
            color: 'rgba(25, 90, 124, .8)',
            date: '',
            type: 'Stocks',
            label: 'Mid-Cap Domestic',
            value: '2068.00',
            percentageValue: '20.0%',
          },
          meta: {
            type: '',
            template: [
              {
                name: 'color',
                prompt: 'Color',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'date',
                prompt: 'Date',
                required: false,
                readonly: false,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'type',
                prompt: 'Type',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'label',
                prompt: 'Label',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'value',
                prompt: 'Value',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                precision: 3,
                isObjectId: false,
              },
              {
                name: 'percentageValue',
                prompt: 'PercentageValue',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                hint: 'percent',
                precision: 2,
                isObjectId: false,
              },
            ],
            links: {},
            page: {},
          },
        },
        {
          id: 'small-cap',
          type: '',
          links: {},
          relationships: {},
          attributes: {
            color: 'rgba(25, 90, 124, .6)',
            date: '',
            type: 'Stocks',
            label: 'Small Domestic',
            value: '1034.00',
            percentageValue: '10.0%',
          },
          meta: {
            type: '',
            template: [
              {
                name: 'color',
                prompt: 'Color',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'date',
                prompt: 'Date',
                required: false,
                readonly: false,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'type',
                prompt: 'Type',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'label',
                prompt: 'Label',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'value',
                prompt: 'Value',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                precision: 3,
                isObjectId: false,
              },
              {
                name: 'percentageValue',
                prompt: 'PercentageValue',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                hint: 'percent',
                precision: 2,
                isObjectId: false,
              },
            ],
            links: {},
            page: {},
          },
        },
      ],
      accounts: [
        {
          id: '1',
          type: 'account',
          links: {},
          relationships: {},
          attributes: {
            name: 'Mock Trust',
            institution: 'Schwab',
            percentReturn: '1.153',
            type: 'trust',
            holdings: [
              {
                id: '1',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Corportate Bond',
                  type: '',
                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'us-corp-bond',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
              {
                id: '2',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Corportate Bond',
                  type: '',

                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'us-corp-bond',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
              {
                id: '3',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Corportate Bond',
                  type: '',

                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'us-corp-bond',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
              {
                id: '4',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Corportate Bond',
                  type: '',

                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'us-corp-bond',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
              {
                id: '5',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Large Domestic',
                  type: '',

                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'large-cap',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
              {
                id: '6',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Large Domestic',
                  type: '',

                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'large-cap',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
              {
                id: '7',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Large Domestic',
                  type: '',

                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'large-cap',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
              {
                id: '8',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Mid Domestic',
                  type: '',

                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'mid-cap',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
              {
                id: '9',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Mid Domestic',
                  type: '',

                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'mid-cap',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
              {
                id: '10',
                type: 'holding',
                links: {},
                relationships: {
                  account: {
                    links: {},
                  },
                  household: {
                    links: {},
                  },
                  research: {
                    links: {},
                  },
                },
                attributes: {
                  percentGain: '1.153',
                  otherPosition: '1.00',
                  isDomestic: 'false',
                  disabled: 'false',
                  classificationCategory: 'Small Domestic',
                  type: '',

                  quantity: '21',
                  currentPrice: '49.24',
                  yield: '0.000',
                  cashPosition: '0.00',
                  expenseRatio: '0.00',
                  bondPosition: '0.00',
                  tickerClassification: 'small-cap',
                  costBasis: '0',
                  currentValue: '1034',
                  costBasisPerShare: '1.00',
                  priceDate: '2022-03-01T20:07:13Z',
                  dollarGain: '0.00',
                  stockPosition: '0.00',
                  name: '',
                  ticker: 'VTSAX',
                  externalCategory: '',
                },
                meta: {
                  type: 'holding',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  queries: [
                    {
                      url: '/holding',
                      rel: 'getHoldings',
                      prompt: 'Get Holdings',
                      template: [
                        {
                          name: 'householdId',
                          prompt: 'Household ID',
                          type: 'number',
                        },
                        {
                          name: 'id',
                          prompt: 'ID',
                          type: 'number',
                        },
                        {
                          name: 'accountId',
                          prompt: 'Account ID',
                          type: 'number',
                        },
                        {
                          name: 'orionID',
                          prompt: 'Orion ID',
                          type: 'number',
                        },
                        {
                          name: 'limit',
                          prompt: '',
                          type: 'number',
                          default: '15',
                        },
                        {
                          name: 'offset',
                          prompt: '',
                          type: 'number',
                          default: '0',
                        },
                        {
                          name: 'sort',
                          prompt: '',
                          type: 'multipicklist',
                        },
                      ],
                    },
                  ],
                  page: {},
                },
              },
            ],
            isManaged: 'true',
            lastSync: '2022-03-01T20:07:11Z',
            dollarReturn: '1.00',
            accountType: 'non_retirement_account',
            balance: '10340',
            facetModel: 'Cash.e',
          },
          meta: {
            type: 'portfolioAccount',
            template: [
              {
                name: 'name',
                prompt: 'Name',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'institution',
                prompt: 'Institution',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                max: 100,
                isObjectId: false,
              },
              {
                name: 'percentReturn',
                prompt: 'Percent Return',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                isObjectId: false,
              },
              {
                name: 'type',
                prompt: 'Account / Liability Type',
                required: false,
                readonly: true,
                hidden: false,
                type: 'picklist',
                options: [
                  {
                    id: 'brokerage',
                    prompt: 'Brokerage',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'checking',
                    prompt: 'Checking',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'fsa',
                    prompt: 'Flexible Spending Account',
                    group: 'Flexible Spending Account',
                    depends: [
                      'health_savings_account',
                    ],
                  },
                  {
                    id: 'Prepaid college trust',
                    prompt: 'Prepaid College Trust',
                    group: 'Education Account',
                    depends: [
                      'education_account',
                    ],
                  },
                  {
                    id: 'personalLineOfCredit',
                    prompt: 'Personal Line of Credit',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'lifeInsurancePolicyLoan',
                    prompt: 'Life Insurance Policy Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'espOther',
                    prompt: 'Other',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: '529 plan',
                    prompt: '529 Plan',
                    group: 'Education Account',
                    depends: [
                      'education_account',
                    ],
                  },
                  {
                    id: 'simple',
                    prompt: 'Simple',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'mortgage',
                    prompt: 'Mortgage',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'stock',
                    prompt: 'Stock',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'esop',
                    prompt: 'Employee Stock Ownership Plan (ESOP)',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'espp',
                    prompt: 'Employee Stock Purchase Plan (ESPP)',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'rolloverIra',
                    prompt: 'Rollover IRA',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'rsus',
                    prompt: 'Restricted Stock Units (RSUs)',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: '401a',
                    prompt: '401-A',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'roth',
                    prompt: 'Roth IRA',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'retirement',
                    prompt: 'Retirement',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'sos',
                    prompt: 'Stock Options (SOs)',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'cd',
                    prompt: 'CD',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'inherited',
                    prompt: 'Inherited',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'trust',
                    prompt: 'Trust',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'profit-sharing',
                    prompt: 'Profit Sharing',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'deferred-compensation',
                    prompt: 'Deferred Compensation',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'traditional',
                    prompt: 'Traditional',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'tsp',
                    prompt: 'TSP',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'annuity',
                    prompt: 'Annuity',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'savings',
                    prompt: 'Savings',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'autoLoan',
                    prompt: 'Auto Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'heloc',
                    prompt: 'HELOC',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'roth401k',
                    prompt: 'Roth 401-K',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: '457b',
                    prompt: '457-B',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: '403b',
                    prompt: '403-B',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'investmentMarginLoan',
                    prompt: 'Investment Margin Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'retirementPlanLoan',
                    prompt: 'Retirement Plan Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'praOther',
                    prompt: 'Other',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'nraOther',
                    prompt: 'Other',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'liabilityOther',
                    prompt: 'Other',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: '401k',
                    prompt: '401-K',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'UTMA/UGMA',
                    prompt: 'UTMA/UGMA',
                    group: 'Education Account',
                    depends: [
                      'education_account',
                    ],
                  },
                  {
                    id: 'studentLoan',
                    prompt: 'Student Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'mutual fund',
                    prompt: 'Mutual Fund',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'bankOther',
                    prompt: 'Other',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'hsa',
                    prompt: 'HSA - Health Savings Account',
                    group: 'Health Savings Account',
                    depends: [
                      'health_savings_account',
                    ],
                  },
                  {
                    id: 'sep',
                    prompt: 'SEP',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'creditCard',
                    prompt: 'Credit Card',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'money market',
                    prompt: 'Money Market',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'autoLease',
                    prompt: 'Auto Lease',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'eduOther',
                    prompt: 'Other',
                    group: 'Education Account',
                    depends: [
                      'education_account',
                    ],
                  },
                ],
                depends: 'accountType',
                isObjectId: false,
              },
              {
                name: 'holdings',
                prompt: 'Holdings',
                required: false,
                readonly: true,
                hidden: false,
                type: 'array',
                arrayDef: {
                  type: '',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  page: {},
                },
                isObjectId: false,
              },
              {
                name: 'syncStatus',
                prompt: 'Sync Status',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'externalAccountId',
                prompt: 'External Account ID',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'accountAggregatorMetaId',
                prompt: 'Account Aggregator Meta ID',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                isObjectId: false,
              },
              {
                name: 'isManaged',
                prompt: 'Is Managed',
                required: false,
                readonly: true,
                hidden: false,
                type: 'bool',
                isObjectId: false,
              },
              {
                name: 'lastSync',
                prompt: 'Last Sync',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'dollarReturn',
                prompt: 'Dollar Return',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                isObjectId: false,
              },
              {
                name: 'accountType',
                prompt: 'Account Category',
                required: false,
                readonly: true,
                hidden: false,
                type: 'picklist',
                options: [
                  {
                    id: 'education_account',
                    prompt: 'Education Account',
                  },
                  {
                    id: 'non_retirement_account',
                    prompt: 'Non Retirement Account',
                  },
                  {
                    id: 'employer_sponsored_plan',
                    prompt: 'Employer Sponsored Plan',
                  },
                  {
                    id: 'liability',
                    prompt: 'Liability',
                  },
                  {
                    id: 'bank_account',
                    prompt: 'Bank Account',
                  },
                  {
                    id: 'personal_retirement_account',
                    prompt: 'Personal Retirement Account',
                  },
                  {
                    id: 'health_savings_account',
                    prompt: 'Health Savings Account',
                  },
                ],
                isObjectId: false,
              },
              {
                name: 'balance',
                prompt: 'Balance',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                hint: 'usd',
                precision: 2,
                isObjectId: false,
              },
              {
                name: 'facetModel',
                prompt: 'Facet Model',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
            ],
            links: {},
            page: {},
          },
        },
      ],
      expenseRatio: '0.000%',
      expensesPaid: '$0',
      yield: '0.000%',
    },
    meta: {
      type: 'portfolio',
      template: [
        {
          name: 'categoryChartData',
          prompt: 'CategoryChartData',
          required: false,
          readonly: true,
          hidden: false,
          type: 'array',
          arrayDef: {
            type: '',
            template: [
              {
                name: 'color',
                prompt: 'Color',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'date',
                prompt: 'Date',
                required: false,
                readonly: false,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'type',
                prompt: 'Type',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'label',
                prompt: 'Label',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'value',
                prompt: 'Value',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                precision: 3,
                isObjectId: false,
              },
              {
                name: 'percentageValue',
                prompt: 'PercentageValue',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                hint: 'percent',
                precision: 2,
                isObjectId: false,
              },
            ],
            links: {},
            page: {},
          },
          isObjectId: false,
        },
        {
          name: 'assetClassChartData',
          prompt: 'AssetClassChartData',
          required: false,
          readonly: true,
          hidden: false,
          type: 'array',
          arrayDef: {
            type: '',
            template: [
              {
                name: 'color',
                prompt: 'Color',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'date',
                prompt: 'Date',
                required: false,
                readonly: false,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'type',
                prompt: 'Type',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'label',
                prompt: 'Label',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'value',
                prompt: 'Value',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                precision: 3,
                isObjectId: false,
              },
              {
                name: 'percentageValue',
                prompt: 'PercentageValue',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                hint: 'percent',
                precision: 2,
                isObjectId: false,
              },
            ],
            links: {},
            page: {},
          },
          isObjectId: false,
        },
        {
          name: 'accounts',
          prompt: 'Accounts',
          required: false,
          readonly: true,
          hidden: false,
          type: 'array',
          arrayDef: {
            type: '',
            template: [
              {
                name: 'name',
                prompt: 'Name',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'institution',
                prompt: 'Institution',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                max: 100,
                isObjectId: false,
              },
              {
                name: 'percentReturn',
                prompt: 'Percent Return',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                isObjectId: false,
              },
              {
                name: 'type',
                prompt: 'Account / Liability Type',
                required: false,
                readonly: true,
                hidden: false,
                type: 'picklist',
                options: [
                  {
                    id: 'eduOther',
                    prompt: 'Other',
                    group: 'Education Account',
                    depends: [
                      'education_account',
                    ],
                  },
                  {
                    id: 'praOther',
                    prompt: 'Other',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: '401a',
                    prompt: '401-A',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'fsa',
                    prompt: 'Flexible Spending Account',
                    group: 'Flexible Spending Account',
                    depends: [
                      'health_savings_account',
                    ],
                  },
                  {
                    id: 'annuity',
                    prompt: 'Annuity',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'rsus',
                    prompt: 'Restricted Stock Units (RSUs)',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'investmentMarginLoan',
                    prompt: 'Investment Margin Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'liabilityOther',
                    prompt: 'Other',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: '529 plan',
                    prompt: '529 Plan',
                    group: 'Education Account',
                    depends: [
                      'education_account',
                    ],
                  },
                  {
                    id: 'retirement',
                    prompt: 'Retirement',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'simple',
                    prompt: 'Simple',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'money market',
                    prompt: 'Money Market',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'esop',
                    prompt: 'Employee Stock Ownership Plan (ESOP)',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'autoLease',
                    prompt: 'Auto Lease',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'bankOther',
                    prompt: 'Other',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'hsa',
                    prompt: 'HSA - Health Savings Account',
                    group: 'Health Savings Account',
                    depends: [
                      'health_savings_account',
                    ],
                  },
                  {
                    id: 'sos',
                    prompt: 'Stock Options (SOs)',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'cd',
                    prompt: 'CD',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'autoLoan',
                    prompt: 'Auto Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'rolloverIra',
                    prompt: 'Rollover IRA',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'roth',
                    prompt: 'Roth IRA',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'stock',
                    prompt: 'Stock',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'profit-sharing',
                    prompt: 'Profit Sharing',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'mortgage',
                    prompt: 'Mortgage',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'inherited',
                    prompt: 'Inherited',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'espOther',
                    prompt: 'Other',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: '457b',
                    prompt: '457-B',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'brokerage',
                    prompt: 'Brokerage',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'traditional',
                    prompt: 'Traditional',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'tsp',
                    prompt: 'TSP',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'espp',
                    prompt: 'Employee Stock Purchase Plan (ESPP)',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'lifeInsurancePolicyLoan',
                    prompt: 'Life Insurance Policy Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'retirementPlanLoan',
                    prompt: 'Retirement Plan Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'deferred-compensation',
                    prompt: 'Deferred Compensation',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'creditCard',
                    prompt: 'Credit Card',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'Prepaid college trust',
                    prompt: 'Prepaid College Trust',
                    group: 'Education Account',
                    depends: [
                      'education_account',
                    ],
                  },
                  {
                    id: 'checking',
                    prompt: 'Checking',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'studentLoan',
                    prompt: 'Student Loan',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'trust',
                    prompt: 'Trust',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'personalLineOfCredit',
                    prompt: 'Personal Line of Credit',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: '401k',
                    prompt: '401-K',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: '403b',
                    prompt: '403-B',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'UTMA/UGMA',
                    prompt: 'UTMA/UGMA',
                    group: 'Education Account',
                    depends: [
                      'education_account',
                    ],
                  },
                  {
                    id: 'heloc',
                    prompt: 'HELOC',
                    group: 'Liability',
                    depends: [
                      'liability',
                    ],
                  },
                  {
                    id: 'nraOther',
                    prompt: 'Other',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                  {
                    id: 'roth401k',
                    prompt: 'Roth 401-K',
                    group: 'Employer Sponsored Plan',
                    depends: [
                      'employer_sponsored_plan',
                    ],
                  },
                  {
                    id: 'sep',
                    prompt: 'SEP',
                    group: 'Personal Retirement Account',
                    depends: [
                      'personal_retirement_account',
                    ],
                  },
                  {
                    id: 'savings',
                    prompt: 'Savings',
                    group: 'Bank Account',
                    depends: [
                      'bank_account',
                    ],
                  },
                  {
                    id: 'mutual fund',
                    prompt: 'Mutual Fund',
                    group: 'Non-retirement Account',
                    depends: [
                      'non_retirement_account',
                    ],
                  },
                ],
                depends: 'accountType',
                isObjectId: false,
              },
              {
                name: 'holdings',
                prompt: 'Holdings',
                required: false,
                readonly: true,
                hidden: false,
                type: 'array',
                arrayDef: {
                  type: '',
                  template: [
                    {
                      name: 'percentGain',
                      prompt: 'Gain/Loss(%)',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'otherPosition',
                      prompt: 'Other Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'isDomestic',
                      prompt: 'Domestic Stock',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'bool',
                      isObjectId: false,
                    },
                    {
                      name: 'disabled',
                      prompt: 'Disabled',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'bool',
                      default: 'false',
                      isObjectId: false,
                    },
                    {
                      name: 'classificationCategory',
                      prompt: 'Classification Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                    {
                      name: 'type',
                      prompt: 'Type',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 255,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'quantity',
                      prompt: 'Quantity',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      max: 9999999,
                      min: -9999999,
                      precision: 3,
                      isObjectId: false,
                    },
                    {
                      name: 'currentPrice',
                      prompt: 'Current Price',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'yield',
                      prompt: 'Yield',
                      required: false,
                      readonly: true,
                      hidden: true,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'cashPosition',
                      prompt: 'Cash Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'expenseRatio',
                      prompt: 'Expense Ratio',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      max: 9999999,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'bondPosition',
                      prompt: 'Bond Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'tickerClassification',
                      prompt: 'Ticker Classification',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'picklist',
                      options: [
                        {
                          id: 'unclassified',
                          prompt: 'Unclassified',
                        },
                        {
                          id: 'large-cap',
                          prompt: 'Large Domestic',
                        },
                        {
                          id: 'mid-cap',
                          prompt: 'Mid-Cap Domestic',
                        },
                        {
                          id: 'small-cap',
                          prompt: 'Small Domestic',
                        },
                        {
                          id: 'target-date',
                          prompt: 'Target Date',
                        },
                        {
                          id: 'intl-developed-markets',
                          prompt: 'Developed International',
                        },
                        {
                          id: 'intl-emerging-markets',
                          prompt: 'Emerging International',
                        },
                        {
                          id: 'cash',
                          prompt: 'Cash',
                        },
                        {
                          id: 'us-govt-bond',
                          prompt: 'Government Bond',
                        },
                        {
                          id: 'muni-bond',
                          prompt: 'Municipal Bond',
                        },
                        {
                          id: 'intl-bond',
                          prompt: 'International Bond',
                        },
                        {
                          id: 'us-corp-bond',
                          prompt: 'Corporate Bond',
                        },
                        {
                          id: 'unclassified-stock',
                          prompt: 'Unclassified Stock',
                        },
                        {
                          id: 'unclassified-bond',
                          prompt: 'Unclassified Bond',
                        },
                      ],
                      isObjectId: false,
                    },
                    {
                      name: 'costBasis',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'currentValue',
                      prompt: 'Current Value',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      isObjectId: false,
                    },
                    {
                      name: 'costBasisPerShare',
                      prompt: 'Cost Basis',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      min: -9999999,
                      isObjectId: false,
                    },
                    {
                      name: 'priceDate',
                      prompt: 'Date of Value',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'datetime',
                      isObjectId: false,
                    },
                    {
                      name: 'dollarGain',
                      prompt: 'Dollar Gain',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'usd',
                      max: 9999999,
                      precision: 2,
                      isObjectId: false,
                    },
                    {
                      name: 'stockPosition',
                      prompt: 'Stock Position',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'number',
                      hint: 'percent',
                      isObjectId: false,
                    },
                    {
                      name: 'name',
                      prompt: 'Name',
                      required: false,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 250,
                      min: 0,
                      isObjectId: false,
                    },
                    {
                      name: 'ticker',
                      prompt: 'Ticker',
                      required: true,
                      readonly: false,
                      hidden: false,
                      type: 'string',
                      max: 25,
                      min: 1,
                      isObjectId: false,
                    },
                    {
                      name: 'externalCategory',
                      prompt: 'External Category',
                      required: false,
                      readonly: true,
                      hidden: false,
                      type: 'string',
                      isObjectId: false,
                    },
                  ],
                  links: {},
                  page: {},
                },
                isObjectId: false,
              },
              {
                name: 'syncStatus',
                prompt: 'Sync Status',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'externalAccountId',
                prompt: 'External Account ID',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'accountAggregatorMetaId',
                prompt: 'Account Aggregator Meta ID',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                isObjectId: false,
              },
              {
                name: 'isManaged',
                prompt: 'Is Managed',
                required: false,
                readonly: true,
                hidden: false,
                type: 'bool',
                isObjectId: false,
              },
              {
                name: 'lastSync',
                prompt: 'Last Sync',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
              {
                name: 'dollarReturn',
                prompt: 'Dollar Return',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                isObjectId: false,
              },
              {
                name: 'accountType',
                prompt: 'Account Category',
                required: false,
                readonly: true,
                hidden: false,
                type: 'picklist',
                options: [
                  {
                    id: 'education_account',
                    prompt: 'Education Account',
                  },
                  {
                    id: 'non_retirement_account',
                    prompt: 'Non Retirement Account',
                  },
                  {
                    id: 'employer_sponsored_plan',
                    prompt: 'Employer Sponsored Plan',
                  },
                  {
                    id: 'liability',
                    prompt: 'Liability',
                  },
                  {
                    id: 'bank_account',
                    prompt: 'Bank Account',
                  },
                  {
                    id: 'personal_retirement_account',
                    prompt: 'Personal Retirement Account',
                  },
                  {
                    id: 'health_savings_account',
                    prompt: 'Health Savings Account',
                  },
                ],
                isObjectId: false,
              },
              {
                name: 'balance',
                prompt: 'Balance',
                required: false,
                readonly: true,
                hidden: false,
                type: 'number',
                hint: 'usd',
                precision: 2,
                isObjectId: false,
              },
              {
                name: 'facetModel',
                prompt: 'Facet Model',
                required: false,
                readonly: true,
                hidden: false,
                type: 'string',
                isObjectId: false,
              },
            ],
            links: {},
            page: {},
          },
          isObjectId: false,
        },
      ],
      links: {},
      queries: [],
      page: {},
    },
  },
];
